// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";

var Raw = {};

var query = GraphqlTag.gql(["fragment MenuFragment on AcademyMenuNode   {\n__typename  \nid  \ntitle  \ndescription  \nhasActivities  \nparentId  \n}\n"]);

function parse(value) {
  var value$1 = value.description;
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          description: !(value$1 == null) ? value$1 : undefined,
          hasActivities: value.hasActivities,
          parentId: value.parentId
        };
}

function serialize(value) {
  var value$1 = value.parentId;
  var value$2 = value.hasActivities;
  var value$3 = value.description;
  var description = value$3 !== undefined ? value$3 : null;
  var value$4 = value.title;
  var value$5 = value.id;
  var value$6 = value.__typename;
  return {
          __typename: value$6,
          id: value$5,
          title: value$4,
          description: description,
          hasActivities: value$2,
          parentId: value$1
        };
}

function verifyArgsAndParse(_MenuFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var MenuFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["fragment ActivityFragment on AcademyActivity   {\n__typename  \nid  \ntitle  \nmenuNodeId  \n}\n"]);

function parse$1(value) {
  return {
          __typename: value.__typename,
          id: value.id,
          title: value.title,
          menuNodeId: value.menuNodeId
        };
}

function serialize$1(value) {
  var value$1 = value.menuNodeId;
  var value$2 = value.title;
  var value$3 = value.id;
  var value$4 = value.__typename;
  return {
          __typename: value$4,
          id: value$3,
          title: value$2,
          menuNodeId: value$1
        };
}

function verifyArgsAndParse$1(_ActivityFragment, value) {
  return parse$1(value);
}

function verifyName$1(param) {
  
}

var ActivityFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};

var Raw$2 = {};

var query$2 = GraphqlTag.gql(["fragment AcademyMatrixCategoryActivityFragment on AcademyMatrixCategoryActivity   {\n__typename  \nid  \ncontentId  \nkind  \ncontentKind  \nbestAttempt  \nlatestAttempt  \nattempts  \nstarted  \n}\n"]);

function parse$2(value) {
  var value$1 = value.contentKind;
  var tmp;
  switch (value$1) {
    case "audio" :
        tmp = "audio";
        break;
    case "custom_word_list" :
        tmp = "custom_word_list";
        break;
    case "example_sentence" :
        tmp = "example_sentence";
        break;
    case "monster_chef" :
        tmp = "monster_chef";
        break;
    case "not_set" :
        tmp = "not_set";
        break;
    case "phonics" :
        tmp = "phonics";
        break;
    case "sound_train" :
        tmp = "sound_train";
        break;
    case "tupperware" :
        tmp = "tupperware";
        break;
    case "video" :
        tmp = "video";
        break;
    case "whack_a_munk" :
        tmp = "whack_a_munk";
        break;
    case "word" :
        tmp = "word";
        break;
    case "word_list" :
        tmp = "word_list";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  var value$2 = value.bestAttempt;
  var value$3 = value.latestAttempt;
  var value$4 = value.started;
  return {
          __typename: value.__typename,
          id: value.id,
          contentId: value.contentId,
          kind: value.kind,
          contentKind: tmp,
          bestAttempt: !(value$2 == null) ? value$2 : undefined,
          latestAttempt: !(value$3 == null) ? value$3 : undefined,
          attempts: value.attempts,
          started: !(value$4 == null) ? value$4 : undefined
        };
}

function serialize$2(value) {
  var value$1 = value.started;
  var started = value$1 !== undefined ? value$1 : null;
  var value$2 = value.attempts;
  var value$3 = value.latestAttempt;
  var latestAttempt = value$3 !== undefined ? value$3 : null;
  var value$4 = value.bestAttempt;
  var bestAttempt = value$4 !== undefined ? value$4 : null;
  var value$5 = value.contentKind;
  var contentKind = typeof value$5 === "object" ? value$5.VAL : (
      value$5 === "not_set" ? "not_set" : (
          value$5 === "example_sentence" ? "example_sentence" : (
              value$5 === "word" ? "word" : (
                  value$5 === "word_list" ? "word_list" : (
                      value$5 === "whack_a_munk" ? "whack_a_munk" : (
                          value$5 === "phonics" ? "phonics" : (
                              value$5 === "sound_train" ? "sound_train" : (
                                  value$5 === "tupperware" ? "tupperware" : (
                                      value$5 === "monster_chef" ? "monster_chef" : (
                                          value$5 === "audio" ? "audio" : (
                                              value$5 === "video" ? "video" : "custom_word_list"
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  var value$6 = value.kind;
  var value$7 = value.contentId;
  var value$8 = value.id;
  var value$9 = value.__typename;
  return {
          __typename: value$9,
          id: value$8,
          contentId: value$7,
          kind: value$6,
          contentKind: contentKind,
          bestAttempt: bestAttempt,
          latestAttempt: latestAttempt,
          attempts: value$2,
          started: started
        };
}

function verifyArgsAndParse$2(_AcademyMatrixCategoryActivityFragment, value) {
  return parse$2(value);
}

function verifyName$2(param) {
  
}

var AcademyMatrixCategoryActivityFragment = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  verifyArgsAndParse: verifyArgsAndParse$2,
  verifyName: verifyName$2
};

var Raw$3 = {};

var query$3 = GraphqlTag.gql([
      "fragment AcademyMatrixActivityFragment on AcademyMatrixActivity   {\n__typename  \nfirst  \nlast  \nstudentId  \nactivities  {\n...AcademyMatrixCategoryActivityFragment   \n}\n\n}\n",
      ""
    ], query$2);

function parse$3(value) {
  var value$1 = value.activities;
  return {
          __typename: value.__typename,
          first: value.first,
          last: value.last,
          studentId: value.studentId,
          activities: value$1.map(function (value) {
                return parse$2(value);
              })
        };
}

function serialize$3(value) {
  var value$1 = value.activities;
  var activities = value$1.map(function (value) {
        return serialize$2(value);
      });
  var value$2 = value.studentId;
  var value$3 = value.last;
  var value$4 = value.first;
  var value$5 = value.__typename;
  return {
          __typename: value$5,
          first: value$4,
          last: value$3,
          studentId: value$2,
          activities: activities
        };
}

function verifyArgsAndParse$3(_AcademyMatrixActivityFragment, value) {
  return parse$3(value);
}

function verifyName$3(param) {
  
}

var AcademyMatrixActivityFragment = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  verifyArgsAndParse: verifyArgsAndParse$3,
  verifyName: verifyName$3
};

var Raw$4 = {};

var query$4 = GraphqlTag.gql(["fragment AcademyMatrixCategoryAggregateFragment on AcademyMatrixCategoryAggregate   {\n__typename  \ncategoryId  \navgBestCategoryAttempts  \navgLatestCategoryAttempts  \ntotalCategoryAttempts  \nuniqueActivityCount  \ntotalActivityCount  \n}\n"]);

function parse$4(value) {
  var value$1 = value.avgBestCategoryAttempts;
  var value$2 = value.avgLatestCategoryAttempts;
  var value$3 = value.totalCategoryAttempts;
  var value$4 = value.uniqueActivityCount;
  return {
          __typename: value.__typename,
          categoryId: value.categoryId,
          avgBestCategoryAttempts: !(value$1 == null) ? value$1 : undefined,
          avgLatestCategoryAttempts: !(value$2 == null) ? value$2 : undefined,
          totalCategoryAttempts: !(value$3 == null) ? value$3 : undefined,
          uniqueActivityCount: !(value$4 == null) ? value$4 : undefined,
          totalActivityCount: value.totalActivityCount
        };
}

function serialize$4(value) {
  var value$1 = value.totalActivityCount;
  var value$2 = value.uniqueActivityCount;
  var uniqueActivityCount = value$2 !== undefined ? value$2 : null;
  var value$3 = value.totalCategoryAttempts;
  var totalCategoryAttempts = value$3 !== undefined ? value$3 : null;
  var value$4 = value.avgLatestCategoryAttempts;
  var avgLatestCategoryAttempts = value$4 !== undefined ? value$4 : null;
  var value$5 = value.avgBestCategoryAttempts;
  var avgBestCategoryAttempts = value$5 !== undefined ? value$5 : null;
  var value$6 = value.categoryId;
  var value$7 = value.__typename;
  return {
          __typename: value$7,
          categoryId: value$6,
          avgBestCategoryAttempts: avgBestCategoryAttempts,
          avgLatestCategoryAttempts: avgLatestCategoryAttempts,
          totalCategoryAttempts: totalCategoryAttempts,
          uniqueActivityCount: uniqueActivityCount,
          totalActivityCount: value$1
        };
}

function verifyArgsAndParse$4(_AcademyMatrixCategoryAggregateFragment, value) {
  return parse$4(value);
}

function verifyName$4(param) {
  
}

var AcademyMatrixCategoryAggregateFragment = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  verifyArgsAndParse: verifyArgsAndParse$4,
  verifyName: verifyName$4
};

var Raw$5 = {};

var query$5 = GraphqlTag.gql([
      "fragment AcademyMatrixAggregateFragment on AcademyMatrixAggregate   {\n__typename  \nfirst  \nlast  \nstudentId  \ncategoryAggregates  {\n...AcademyMatrixCategoryAggregateFragment   \n}\n\n}\n",
      ""
    ], query$4);

function parse$5(value) {
  var value$1 = value.categoryAggregates;
  return {
          __typename: value.__typename,
          first: value.first,
          last: value.last,
          studentId: value.studentId,
          categoryAggregates: value$1.map(function (value) {
                return parse$4(value);
              })
        };
}

function serialize$5(value) {
  var value$1 = value.categoryAggregates;
  var categoryAggregates = value$1.map(function (value) {
        return serialize$4(value);
      });
  var value$2 = value.studentId;
  var value$3 = value.last;
  var value$4 = value.first;
  var value$5 = value.__typename;
  return {
          __typename: value$5,
          first: value$4,
          last: value$3,
          studentId: value$2,
          categoryAggregates: categoryAggregates
        };
}

function verifyArgsAndParse$5(_AcademyMatrixAggregateFragment, value) {
  return parse$5(value);
}

function verifyName$5(param) {
  
}

var AcademyMatrixAggregateFragment = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  verifyArgsAndParse: verifyArgsAndParse$5,
  verifyName: verifyName$5
};

export {
  MenuFragment ,
  ActivityFragment ,
  AcademyMatrixCategoryActivityFragment ,
  AcademyMatrixActivityFragment ,
  AcademyMatrixCategoryAggregateFragment ,
  AcademyMatrixAggregateFragment ,
}
/* query Not a pure module */
